import { A } from '@solidjs/router';
import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import type { CardView } from '../../lib/machine-card';
import { orgHref } from '../../lib/org';
import { CardAction } from './CardAction';

// The card's footer (#6785, prototype `:2466`): the reason and "last seen" in a quiet
// state, just "last seen" in a loud one (its banner already says the rest); the Agents
// link (the page is org-wide, so no "for this machine"); and the quiet state's action.

export function CardFooter(props: {
  readonly view: CardView;
  readonly onAction: () => void;
}): JSX.Element {
  return (
    <footer class="mission-card__foot">
      <span class="mission-card__foot-text">
        <Show when={props.view.footer.reason}>{(reason) => <>{reason()} · </>}</Show>
        <span class="mission-card__seen">{props.view.footer.seen}</span>
      </span>
      <span class="mission-card__foot-acts">
        <A
          class="mission-card__agents"
          href={orgHref('/fleet/agents')}
          title={t('fleet.machines.card_agents_title')}
        >
          {t('fleet.machines.card_agents')}
          <span aria-hidden="true">↗</span>
        </A>
        <Show when={!props.view.loud && props.view.action}>
          {(label) => (
            <CardAction
              label={label()}
              tone={props.view.tone}
              size="footer"
              onPress={props.onAction}
            />
          )}
        </Show>
      </span>
    </footer>
  );
}
